'use strict';

module.exports = {
  REDEEM_PROMO_CODE: 'redeem-promo-code',
};
